import ReView from '~/ReView';

import Log from '~/_Utility/Log';

class WooCommerce {

    /**
     * @since 2.14.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.events = {
            cartUpdated: [
                'wc_fragments_loaded',
                'wc_cart_emptied',
                'updated_cart_totals'
            ]
        };
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.14.0
     * @return void
     */
    init() {
        // Probably listen for the masonry thing here
        new Log('WooCommerce initialized.', 'init');

        // Declare and initialize
        let cartUpdatedSelector = this.events.cartUpdated.join(' ');

        // Update the card icon when the cart is updated
        $(document.body).on(cartUpdatedSelector, this.refreshCart);

        // Run the password meter
        this.passwordMeter();
    }

    /**
     * Run the password meter when a user is trying to set a password.
     *
     * @since 2.18.3
     * @method passwordMeter
     * @return void
     */
    passwordMeter() {
        // Declare and initialize
        let strength = '.woocommerce-password-strength';
        let hint     = '.woocommerce-password-hint';
        let notices  = strength + ', ' + hint;

        $('form').on('keyup', '#reg_password', function (event) {

            // Declare and initialize
            let form   = $(this).closest('form');
            let submit = form.find('[type="submit"]');

            if ($(this).val() != '') {

                // Show the notices
                $(notices).show();

                // Check the password strength
                checkPasswordStrength(
                    $(this),
                    $(this),
                    $(strength),
                    submit
                );

            } else {

                // Password is empty, do not show notices
                $(notices).hide();

            }

        });

        function checkPasswordStrength(password, confirm_password, notice, submit) {

            // Declare and initialize
            var password  = password.val();
            var blacklist = wp.passwordStrength.userInputDisallowedList();
            var strength  = wp.passwordStrength.meter(password, blacklist, password);

            // Disable submission while we are checking strength
            submit.attr('disabled', 'disabled');

            // Clear out previous test classes
            notice.removeClass('short bad good strong');

            switch (strength) {
                case 2:
                    notice.addClass('bad').html(pwsL10n.bad);
                    break;
                case 3:
                    notice.addClass('good').html(pwsL10n.good);
                    break;
                case 4:
                    notice.addClass('strong').html(pwsL10n.strong);
                    break;
                case 5:
                    notice.addClass('short').html(pwsL10n.mismatch);
                    break;
                default:
                    notice.addClass('short').html(pwsL10n.short);
            }

            // We should be good - let the user submit
            if (4 === strength && '' !== password.trim())
                submit.removeAttr('disabled');

            // Send back the strength for reference
            return strength;
        }
    }

    /**
     * Refresh the contents of the cart dynamically.
     *
     * @since 2.14.0
     * @method refreshCart
     * @return void
     */
    refreshCart() {
        // Run the review
        new ReView('header/navbar-cart', true);
    }
}

export default WooCommerce;